import React from 'react'
import Autocomplete from 'react-autocomplete'
import '../styles/login.css'

import apigClientFactory from 'aws-api-gateway-client'
import aws from '../aws-config'

import { corporations } from '../corps'

export default class Login extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      isLoading: false,
      isAuthenticated: false,
      firstName: '',
      lastName: '',
      email: '',
      employer: '',
      division: '',
      confirmEmail: '',
      errorMsg: ""
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value,
    })
  }

  verifyEmails = () => {

    if(this.state.email !== this.state.confirmEmail) {
      this.setState({
        errorMsg: "Email does not match"
      })
      return false
    } else {
      console.log("match");
      return true
    }
  }

  isVerified = () => {

    return this.state.firstName.length > 0 &&
      this.state.lastName.length > 0 &&
      this.state.email.length > 0 &&
      this.state.employer.length > 0 &&
      this.state.confirmEmail.length > 0
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({
      isLoading: true
    })

    if (!this.verifyEmails()) {
      return
    }

    const apigClient = apigClientFactory.newClient({
      invokeUrl: aws.apiGateway.URL,
      region: aws.apiGateway.REGION,
      retryCondition: (err) => {
        return err.response.status === 500
      }
    })

    let headers = {'Access-Control-Allow-Origin': '*'}
    let pathTemplate = '/icare/auth'
    let method = 'POST'
    let params = {
      queryParams: {
        email: this.state.email,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        employer: this.state.employer,
        division: this.state.division? this.state.division : 'nil'
      }
    }

    apigClient.invokeApi(headers, pathTemplate, method, params)
      .then(() => {

        this.setState({
          isLoading: false,
          isAuthenticated: true
        })
        let user = {
          "email": this.state.email,
          "firstName": this.state.firstName,
          "lastName": this.state.lastName,
          "employer": this.state.employer,
          "division": this.state.division,
          "registrationDate": new Date().getTime(),
          "lastLogin": false,
          "captions": false,
          "quizData": {
            "introduction": 0,
            "informative": 0,
            "courteous": 0,
            "approachable": 0,
            "responsive": 0,
            "efficient_effective": 0
          },
        }
        this.props.userHasAuthenticated(this.state.isAuthenticated, user)
      })
      .catch(error => {
        console.log('err: ', error)
      })
  }

  shouldRender = (item, value) => {
    return (
      item.Name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    )
  }
  renderMenu = (items, value, style) => {
    return (
      <div
        style={{...style, ...this.menuStyle}}
        children={items.slice(0, 10)}
      />
    )
  }

  render() {
    return (
      <div className="login">
        <img src="//d2bsj3sc0hks5v.cloudfront.net/icare/background-image.png" className="bg" alt="" />
        <h2>Welcome to iCare LAWA Training Suite</h2>
        <p>
          Thank you for your commitment to provide “LAXceptional Xperiences” to the millions of guests that come through our doors each year.
          As often the first and last impression of the City of Los Angeles,
          your role as an ambassador to this airport and our city is valued and appreciated.
        </p>
        <p>
          The iCARE training suite is one of our guest experience tools to provide the foundation of knowledge to help you
          demonstrate that you care to be informative, courteous, approachable, responsive, efficient and effective.
          The importance of creating exceptional experiences for our guests will help us to continue to serve the world,
          connecting people, places and cultures.
        </p>
        <form onSubmit={this.handleSubmit}>
          <h3>New user registration.</h3>
          <div className="login-form">
            <label className="text-input">First name: *</label>
            <input id="firstName"
                   name="firstName"
                   type="text"
                   className="login-input"
                   value={this.state.firstName}
                   onChange={this.handleChange}
                   autoComplete='given-name'
                   required
            />
          </div>
          <div className="login-form">
            <label className="text-input">Last name: *</label>
            <input id="lastName"
                   name="lastName"
                   type="text"
                   className="login-input"
                   value={this.state.lastName}
                   onChange={this.handleChange}
                   autoComplete='family-name'
                   required
            />
          </div>
          <div className="login-form">
            <label className="text-input">Email Address: *</label>
            <input id="email"
                   name="email"
                   type="email"
                   className="login-input"
                   value={this.state.email}
                   onChange={this.handleChange}
                   autoComplete='email'
                   required
            />
          </div>
          <div className="login-form">
            <label className="text-input">Confirm Email Address: *</label>
            <input id="confirmEmail"
                   name="confirmEmail"
                   type="email"
                   className="login-input"
                   value={this.state.confirmEmail}
                   onChange={this.handleChange}
                   autoComplete='email'
                   required
            />
          </div>
          <div className="login-form">
            <label className="text-input">Employer: *</label>
            <Autocomplete inputProps={{ id: 'employee' }}
                          value={this.state.employer}
                          items={corporations()}
                          getItemValue={(item) => item.Name}
                          shouldItemRender={this.shouldRender}
                          renderMenu={this.renderMenu}
                          renderItem={(item, isHighlighted) =>
                            <div style={{ background: isHighlighted ? 'lightgray' : 'white' }}
                            key={item.Name}>
                            {item.Name}
                            </div>
                          }
                          onChange={(event, value) => this.setState({employer: value})}
                          onSelect={(val) => this.setState({employer: val})}

            />
          </div>
          {/*{this.state.employer === 'LAWA' && (*/}
            {/*<div className="login-form">*/}
              {/*<label className="text-input">Divisions:</label>*/}
              {/*<select id="division" value={this.state.division} onChange={this.handleChange}>*/}
                {/*<option value=""></option>*/}
                {/*<option value="ADMINISTRATION">ADMINISTRATION</option>*/}
                {/*<option value="ADMINISTRATIVE SERVICES">ADMINISTRATIVE SERVICES</option>*/}
                {/*<option value="AIRFIELD PERMITS">AIRFIELD PERMITS</option>*/}
                {/*<option value="AIRPORTS DEVELOPMENT GROUP">AIRPORTS DEVELOPMENT GROUP</option>*/}
                {/*<option value="AIRPORT OPERATION">AIRPORT OPERATION</option>*/}
                {/*<option value="AIRPORT POLICE">AIRPORT POLICE</option>*/}
                {/*<option value="CAPITAL PROGRAMMING AND PLANNING GROUP">CAPITAL PROGRAMMING AND PLANNING GROUP</option>*/}
                {/*<option value="COMMISSION">COMMISSION</option>*/}
                {/*<option value="EMERGENCY MANAGEMENT">EMERGENCY MANAGEMENT</option>*/}
                {/*<option value="ENGINEERING AND FACILITIES MGMT DIV">ENGINEERING AND FACILITIES MGMT DIV</option>*/}
                {/*<option value="ENVIRONMENTAL PROGRAMS">ENVIRONMENTAL PROGRAMS</option>*/}
                {/*<option value="ENVIRONMENTAL SERVICES">ENVIRONMENTAL SERVICES</option>*/}
                {/*<option value="FINANCIAL SERVICES">FINANCIAL SERVICES</option>*/}
                {/*<option value="GOVERNMENT AND EXTERNAL AFFAIRS">GOVERNMENT AND EXTERNAL AFFAIRS</option>*/}
                {/*<option value="GUEST SERVICE">GUEST SERVICES</option>*/}
                {/*<option value="INFORMATION TECHNOLOGY">INFORMATION TECHNOLOGY</option>*/}
                {/*<option value="MTCE SERVICES DIVISION">MTCE SERVICES DIVISION</option>*/}
                {/*<option value="PLANNING AND DEVELPMENT GROUP">PLANNING AND DEVELPMENT GROUP</option>*/}
                {/*<option value="PROJECT AND FACILITIES DEV">PROJECT AND FACILITIES DEV</option>*/}
                {/*<option value="PUBLIC AND COMMUNITY RELATIONS">PUBLIC AND COMMUNITY RELATIONS</option>*/}
                {/*<option value="VOLUNTEER INFO PROFESSIONAL">VOLUNTEER INFO PROFESSIONAL</option>*/}
              {/*</select>*/}
            {/*</div>*/}
          {/*)}*/}
          <button type="button" disabled={!this.isVerified()} value="submit" className="btn btn-primary" onClick={this.handleSubmit}>Register</button>
        </form>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/Login.js